import Component from '../lib/Component'
import { addClass, removeClass } from '../lib/Utils'

export default class TeamCarousel extends Component {
	static selector = '[data-team-carousel]'

	initialize() {
		const $teamCarousel = this.$$('.js-team-carousel')

		if ($teamCarousel.length > 0) {
			$teamCarousel.forEach((element) => {
				const elem = element.querySelector('.c-team-wrapper')
				const lgItems = elem.dataset.itemsDesktop
				const mdItems = elem.dataset.itemsTablet
				const smItems = elem.dataset.itemsMobile
				const lgGutter = elem.dataset.gutterDesktop
				const mdGutter = elem.dataset.gutterTablet
				const smGutter = elem.dataset.gutterMobile
				const nav = elem.dataset.nav
				const controls = element.querySelector(
					'[data-team-carousel-controls]',
				)

				const prevButton = controls.querySelector('.js-team-nav-prev')
				const nextButton = controls.querySelector('.js-team-nav-next')

				let navActive = nav

				if (nav) {
					navActive = {
						nextEl: nextButton,
						prevEl: prevButton,
					}
				}

				const swiper = new Swiper(elem, {
					autoHeight: true,
					touchStartPreventDefault: false,
					slidesPerView: lgItems ? lgItems : 4,
					spaceBetween: lgGutter ? lgGutter : 40,
					breakpoints: {
						320: {
							slidesPerView: smItems ? smItems : 1,
							spaceBetween: smGutter ? smGutter : 10,
						},
						640: {
							slidesPerView: mdItems ? mdItems : 2,
							spaceBetween: mdGutter ? mdGutter : 10,
						},
						1140: {
							slidesPerView: lgItems ? lgItems : 4,
							spaceBetween: lgGutter ? lgGutter : 40,
						},
					},
					navigation: navActive,
				})

				swiper.on('sliderMove', () => {
					addClass(elem, 'is-pointer-down')
				})

				swiper.on('transitionEnd', () => {
					removeClass(elem, 'is-pointer-down')
				})
			})
		}
	}
}
